import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginParams } from '../../../shared/params/login-params';
import { AuthService } from '../../service/auth.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.html',
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isSubmitted = false;
  isLoading = false;
  errorMessage: string = '';
  showPassword = false;
  returnUrl: string = '/admin';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';

    this.loginForm.valueChanges.subscribe(() => {
      if (this.errorMessage) {
        this.errorMessage = '';
      }
    });
  }

  get username() {
    return this.loginForm.get('username');
  }

  get password() {
    return this.loginForm.get('password');
  }

  onSubmit(): void {
    this.isSubmitted = true;
    this.errorMessage = '';

    if (this.loginForm.valid) {
      this.isLoading = true;

      const loginParams: LoginParams = {
        username: this.username?.value,
        password: this.password?.value,
      };

      this.authService.login(loginParams.username, loginParams.password).subscribe({
        next: (user) => {
          if (user) {
            localStorage.setItem('loggedInUser', JSON.stringify(user));
            this.router.navigateByUrl(this.returnUrl);      
          } else {
            this.errorMessage = 'Невалидно потребителско име или парола.';
            this.isLoading = false;
          }
        },
        error: (error) => {
          console.error(error);
          this.errorMessage = 'Възникна грешка при вход. Моля, опитайте отново.';
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    } else {
      this.errorMessage = 'Моля, попълнете всички полета коректно.';
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}